import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { LogoutRequest } from '@pages/logout/models/logout-request.interface';

@Injectable({
  providedIn: 'root',
})
export class OpenIdConnectLogoutService {
  private readonly httpClient = inject(HttpClient);

  logOut(logoutRequest: LogoutRequest): Observable<boolean> {
    const url = 'api/v1/connect/logout';

    return this.httpClient.post<boolean>(environment.portalApiUrl + url, logoutRequest);
  }
}
